module.exports = __webpack_public_path__ + "img/1575494897.aea4ad48.jpg";